import { COUNTRY_CODES } from "../../constants/countries";
import { configuracionDePais } from "../../utils/configuracionDePais";

export const DASHBOARD_CONFIG = {
  [COUNTRY_CODES.ECUADOR]: {
    showAbonos: true,
    showHistoricoAbonos: true,
  },
  [COUNTRY_CODES.PARAGUAY]: {
    showAbonos: true,
    showHistoricoAbonos: true,
  },
  [COUNTRY_CODES.PUERTORICO]: {
    showAbonos: true,
    showHistoricoAbonos: true,
  },
  [COUNTRY_CODES.ELSALVADOR]: {
    showAbonos: false,
    showHistoricoAbonos: false,
  },
};
export const getDashboardConfig = (pais) => {
  return configuracionDePais(DASHBOARD_CONFIG, pais, "panel de inicio");
};
